import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppComponent } from '../../../app.component';
import { DemandaService } from '../../../core/services/demanda.service';
import { DemandaResumo, ResumoAnexo } from '../../../shared/models/demanda-resumo';

@Component({
  selector: 'app-demanda-resumo',
  templateUrl: './demanda-resumo.component.html',
  styleUrls: ['./demanda-resumo.component.css']
})
export class DemandaResumoComponent implements OnInit, OnDestroy {
  codigo: number;
  resumo: DemandaResumo;
  carregando = false;
  erro = '';
  erroDownload = '';
  baixando: { [codigo: number]: boolean } = {};
  private subscriptions = new Subscription();
  private consulta: Subscription;

  constructor(private route: ActivatedRoute, private service: DemandaService, private app: AppComponent) {}

  ngOnInit(): void {
    this.app.setTitulo('Resumo da demanda');
    this.subscriptions.add(this.route.paramMap.subscribe(params => {
      this.codigo = Number(params.get('id'));
      this.app.setBreadcrumb([
        { nome: 'Demandas', caminho: '/demanda-listar' },
        { nome: 'Detalhe da Demanda', caminho: '/demanda-exibir/' + this.codigo }
      ]);
      this.carregar();
    }));
  }

  carregar(): void {
    if (this.consulta) { this.consulta.unsubscribe(); }
    this.resumo = null;
    this.erro = '';
    this.erroDownload = '';
    if (!Number.isSafeInteger(this.codigo) || this.codigo <= 0) {
      this.erro = 'Demanda inválida.';
      return;
    }
    this.carregando = true;
    this.consulta = this.service.resumo(this.codigo).subscribe(resumo => {
      this.resumo = resumo;
      this.carregando = false;
    }, error => {
      this.carregando = false;
      this.erro = error.status === 404 ? 'Demanda não encontrada ou indisponível para consulta.' :
        'Não foi possível carregar o resumo da demanda. Tente novamente.';
    });
  }

  baixar(anexo: ResumoAnexo): void {
    this.baixando[anexo.codigo_demanda_anexo] = true;
    this.erroDownload = '';
    this.subscriptions.add(this.service.baixarAnexo(anexo.codigo_demanda, anexo.codigo_demanda_anexo).subscribe(blob => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = anexo.nome;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      this.baixando[anexo.codigo_demanda_anexo] = false;
    }, () => {
      this.baixando[anexo.codigo_demanda_anexo] = false;
      this.erroDownload = 'Não foi possível baixar o arquivo "' + anexo.nome + '". Tente novamente.';
    }));
  }

  ngOnDestroy(): void {
    if (this.consulta) { this.consulta.unsubscribe(); }
    this.subscriptions.unsubscribe();
  }
}
